import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SupplierViewModel } from '@app/_models/_viewModels/supplier.viewmodel';
import { UploadFile, NzMessageService } from 'ng-zorro-antd';
import { Media } from '@app/_models/_DTOs/media';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { ResizeService } from '@app/_services/resize.service';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AutonumericOptions } from '@angularfy/autonumeric/lib/autonumeric.model';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { SupplierService } from '@app/_services/supplier.service';

@Component({
  selector: 'app-supplier-editor',
  templateUrl: './supplier-editor.component.html',
  styleUrls: ['./supplier-editor.component.css']
})
export class SupplierEditorComponent implements OnInit {

  @Input() hiddenFields: string[];
  @Input() disabledFields: string[];
  @Input() supplierViewModel: SupplierViewModel;
  @Input() isEditing: boolean;
  @Output() doneEditing = new EventEmitter<number>();

  public createForm: NgForm;

  drawerWidth: string;

  isSavingSupplier: boolean = false;

  errorMessages = {};

  apiUrl: string;

  private delayTimer;

  constructor(
    private supplierService: SupplierService,
    private messageService: NzMessageService,
    private resizeService: ResizeService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe(size => {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    });
  }

  ngOnInit() {
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    }
  }

  resetForm() {
    this.supplierViewModel = null;
  }

  finish(supplierId: number, form?: NgForm) {
    if (form) {
      form.reset();
    }
    this.supplierViewModel = null;
    this.doneEditing.emit(supplierId);
  }

  pad(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  saveSupplier(form: NgForm) {
    this.isSavingSupplier = true;
    if (this.isEditing) {
      this.supplierService.put(this.supplierViewModel, this.supplierViewModel.id).subscribe(result => {
        this.messageService.create("success", "Dobavljač uspješno izmijenjen",{
          nzDuration: 3000
        });
        this.isSavingSupplier = false;
        this.finish(this.supplierViewModel.id, form);
      }, error => {
        if (error.ParamName) {
          if (form.controls[error.ParamName]) {
            form.controls[error.ParamName].setErrors({ custom: true });
            var errorMessage = error.Message.split("Parameter name")[0];
            this.errorMessages[error.ParamName] = errorMessage;
          }
        }
        this.isSavingSupplier = false;
      });
    }
    else {
      this.supplierService.post<SupplierViewModel>(this.supplierViewModel).subscribe(result => {
        this.messageService.create("success", "Dobavljač uspješno dodan");
        this.isSavingSupplier = false;
        this.finish(result as number, form);
      }, error => {
        if (error.ParamName) {
          if (form.controls[error.ParamName]) {
            form.controls[error.ParamName].setErrors({ custom: true });
            var errorMessage = error.Message.split("Parameter name")[0];
            this.errorMessages[error.ParamName] = errorMessage;
          }
        }
        this.isSavingSupplier = false;
      });
    }
  }

  isFieldHidden(fieldName: string) {
    if (this.hiddenFields) {
      if (this.hiddenFields.length > 0) {
        if (this.hiddenFields.some(x => x == fieldName)) {
          return false;
        }
      }
    }
    return true;
  }

  isFieldEnabled(fieldName: string) {
    if (this.disabledFields) {
      if (this.disabledFields.length > 0) {
        if (this.disabledFields.some(x => x == fieldName)) {
          return false;
        }
      }
    }
    return true;
  }

}
